module.exports = __webpack_public_path__ + "static/img/values.210919a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/values.png
// module id = crSX
// module chunks = 0